export const MAX_ROTATED_TICK_WIDTH = 100;

export const CHART_PADDING = 10;

export const LABEL_PADDING = 12;

export const LEGEND_CIRCLE_SIZE = 10;
export const LEGEND_TEXT_MARGIN = LEGEND_CIRCLE_SIZE * 2;
